import React from 'react'

import {
    LANGUAGE,
    PAYMENT_CHECKOUT_URL,
} from '@bikemap/js/settings'
import { gettext } from '@bikemap/js/services'

import BasePromotionModal from '../BasePromotionModal.jsx'
import { getImageVariants } from '../helpers.js'

const identifier = 'ebike_giveaway'
const plan = 'yearly'
const percentage = 50
const voucher = 'unlock50'

const learnMoreHref = LANGUAGE === 'de'
    ? 'https://help.bikemap.net/hc/de/articles/12773741053852-Bikemap-Gewinnspiel'
    : 'https://help.bikemap.net/hc/en-us/articles/12773741053852-Bikemap-Giveaway'

const Modal = () => {
    const trackingProps = '&utm_source=website&utm_medium=popup&utm_campaign=' + identifier

    const modalProps = {
        label: gettext('Offer & Giveaway'),
        title: gettext('Save {percentage} on Premium + Chance to Win an E-Bike')
            .replace('{percentage}', percentage.toString() + '%'),
        description: gettext('Redeem the voucher code {voucher} to save {percentage} on your Yearly Bikemap Premium membership, unlock all exclusive features and get the chance to win a <b>TENWAYS CGO009 e-bike</b> & more. As a Premium user you will be able join our <b>In-App Giveaway</b> through Bikemap for iOS and Android.')
            .replaceAll('{percentage}', percentage.toString() + '%')
            .replace('{voucher}', '<b>' + voucher.toUpperCase() + '</b>'),
        cta: gettext('Go Premium with {percentage} off')
            .replace('{percentage}', percentage.toString() + '%'),
        imageAlt: gettext('Promotion'),
        img: getImageVariants('tenways-giveaway'),
        ctaLink: PAYMENT_CHECKOUT_URL + '?plan=' + plan + '&voucher=' + voucher + '&skip-welcome=true' + trackingProps,
        finePrint: gettext('The giveaway closes on March 31, 2024. Winners will be drawn the following week.'),
    }

    return (
        <BasePromotionModal
            premium
            {...modalProps}
            learnMoreLink={<a href={learnMoreHref}>{LANGUAGE === 'de' ? <>Mehr&nbsp;erfahren</> : <>Learn&nbsp;more</>}</a>}
        />
    )
}

export default Modal
